import type {ReactElement} from 'react';
import {useRef} from 'react';
import React from 'react';
import type {AlphaPercentagePickerInputFieldProps} from './alpha-percentage-picker-input-field.types';
import {type RGBA} from '@Utils/color.util';
import {InputField} from '@Components/input-field-v2';
import {InputControlItemType, InputFieldType} from '@Components/input-field-v2/input-field.types';

export function AlphaPercentagePickerInputField({className = '', ...props}: AlphaPercentagePickerInputFieldProps): ReactElement<any> {
  const alpha = Math.round(props.color[3] * 100);
  const min = 0;
  const max = 100;
  const onIncrementDecrementTimer = useRef<number | undefined>(undefined);

  const onChangeHandler = (value: number): void => {
    const newColor = props.color.slice();
    let newValue = value;
    if (value > max) {
      newValue = max;
    } else if (value < min) {
      newValue = min;
    }

    newColor[3] = newValue / 100;
    props.onChangeColor(newColor as RGBA);
  };
  const onChangeEnded = (value: number): void => {
    const newColor = props.color.slice();
    let newValue = value;
    if (value > max) {
      newValue = max;
    } else if (value < min) {
      newValue = min;
    }
    newColor[3] = newValue / 100;

    props.onChangeEnded(newColor as RGBA);
  };
  const onIncrementHandler = (): void => {
    const newColor = props.color.slice();
    const incrementedAlphaValue = alpha < 100 ? alpha + 1 : 100;
    newColor[3] = incrementedAlphaValue / 100;

    props.onChangeColor(newColor as RGBA);

    if (onIncrementDecrementTimer) {
      clearTimeout(onIncrementDecrementTimer.current);
    }

    onIncrementDecrementTimer.current = window.setTimeout(() => {
      props.onChangeEnded(newColor as RGBA);
    }, 600);
  };

  const onDecrementHandler = (): void => {
    const newColor = props.color.slice();
    const decrementedAlphaValue = alpha > 0 ? alpha - 1 : 0;

    newColor[3] = decrementedAlphaValue / 100;

    props.onChangeColor(newColor as RGBA);

    if (onIncrementDecrementTimer) {
      clearTimeout(onIncrementDecrementTimer.current);
    }

    onIncrementDecrementTimer.current = window.setTimeout(() => {
      props.onChangeEnded(newColor as RGBA);
    }, 600);
  };

  return (
    <div>
      <InputField
        className={className}
        input={alpha}
        min={0}
        max={100}
        inputType={InputFieldType.NUMBER}
        onInputChange={onChangeHandler}
        onInputChangeEnded={onChangeEnded}
        controls={{
          showDefaultControls: false,
          customControls: [
            {
              id: 'icon-discount',
              type: InputControlItemType.INACTIVE_ICON,
              icon: 'icon-discount',
            },
          ],
        }}
        selectOnFocus
        inputClassName={props.inputClassName}
        onArrowDownKeyDown={onDecrementHandler}
        onArrowUpKeyDown={onIncrementHandler}
      />
    </div>
  );
}
